import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Show } from '../model/recital';

export interface CreateShowParams {
  recitalId: string;
  name: string;
  showDate: string;
  orderInRecital: number;
  capacity?: number;
  notes?: string;
}

export const createShowAPI = async ({
  recitalId,
  ...params
}: CreateShowParams) => {
  const response = await baseAPI.post<Show>(
    `/recitals/${recitalId}/shows`,
    params,
  );
  return response.data;
};

export const useCreateShowMutation = () => {
  return useMutation({
    mutationFn: async (params: CreateShowParams) => {
      return await createShowAPI(params);
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.SHOWS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId, KEYS.STATS],
      });
    },
  });
};
